// extracted by mini-css-extract-plugin
export default {"column":"ColumnLayout_column__9+EgP"};